import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

// Available languages configuration
export const languages = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇺🇸',
    isRTL: false,
  },
  {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    flag: '🇪🇸',
    isRTL: false,
  },
] as const

export type LanguageCode = (typeof languages)[number]['code']

// i18n configuration
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: import.meta.env.DEV,

    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'files', 'admin', 'errors', 'search'],

    interpolation: {
      escapeValue: false, // React already handles XSS
    },

    // Backend configuration for loading translation files
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Language detection configuration
    detection: {
      order: ['localStorage', 'querystring', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'user-language',
      caches: ['localStorage'],
    },

    // React configuration
    react: {
      useSuspense: false, // Disable suspense to avoid loading issues
    },
  })

export default i18n
